import queryString from 'query-string';
import { IKpiItems, ITask, IActivityFeed, IRecentlyViewed } from './types';
import { IEvent } from '../Job/types';

const BASE_URL = window.location.origin;
class Api {
  headers = {
    'Content-Type': 'application/json'
  };

  handleResponse = (response: Response) => {
    if (response.ok) return response.json();
    return response.json().then((error) => {
      error.code = response.status;
      throw error;
    });
  };

  handlePaginatedResponse = async (response: Response) => {
    if (response.ok) {
      return {
        data: await response.json(),
        totalItems: Number(response.headers.get('X-Total-Count')),
        totalPages: Number(response.headers.get('X-Total-Pages')),
        nextPage: Number(response.headers.get('X-Next-Page'))
      };
    }
    return response.json().then((error) => {
      error.code = response.status;
      throw error;
    });
  };

  getPaginated = (path: string, params = {}) =>
    fetch(
      `${BASE_URL}${path}?${queryString.stringify(params, {
        skipEmptyString: true,
        skipNull: true,
        arrayFormat: 'bracket',
        encode: false
      })}`,
      {
        headers: this.headers
      }
    ).then((r) => this.handlePaginatedResponse(r));

  get = (path: string, params = {}) =>
    fetch(
      `${BASE_URL}${path}?${queryString.stringify(params, {
        arrayFormat: 'bracket',
        encode: false
      })}`,
      {
        headers: this.headers
      }
    ).then((r) => this.handleResponse(r));

  post = (path: string, params = {}) =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.headers,
      method: 'POST',
      body: JSON.stringify(params)
    }).then((r) => this.handleResponse(r));

  put = (path: string, params = {}) =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.headers,
      method: 'PUT',
      body: JSON.stringify(params)
    }).then((r) => this.handleResponse(r));

  delete = (path: string, params = {}) =>
    fetch(`${BASE_URL}${path}`, {
      headers: this.headers,
      method: 'DELETE',
      body: JSON.stringify(params)
    }).then((r) => this.handleResponse(r));

  getKpiItems = (): Promise<IKpiItems> => this.get(`/api/v4/dashboard`, {});
  getTasks = (params: {
    page: number;
    to_do: boolean;
  }): Promise<{ data: ITask[]; totalPages: number; totalItems: number; nextPage: number }> =>
    this.getPaginated(`/api/v4/tasks`, { ...params, limit: 10 });
  getEvents = (params: {
    page: number;
  }): Promise<{
    data: { events: IEvent[] };
    totalPages: number;
    totalItems: number;
    nextPage: number;
  }> => this.getPaginated('/api/v4/dashboard/events', { ...params, limit: 10 });
  completeTask = (id: string, completed: boolean) =>
    this.put(`/api/v4/tasks/${id}`, { task: { completed: completed ? 1 : 0 } });
  getActivityFeed = async (params: { page: number | null }): Promise<IActivityFeed[]> => {
    if (params.page === null) {
      return this.get(`/api/v4/dashboard/activities_feed`, { ...params });
    } else {
      await new Promise((resolve) => setTimeout(resolve, 2500));
      return this.get(`/api/v4/dashboard/activities_feed`, { ...params });
    }
  };
  getRecentlyViewed = (): Promise<IRecentlyViewed[]> =>
    this.get(`/api/v4/dashboard/recent_page_views`, {});
  getUserEntities = () =>
    this.get(`/api/v4/user_entities`, {},);
}

export default new Api();
